import { render, staticRenderFns } from "./editCashierTransaction.vue?vue&type=template&id=6b3fbc84&scoped=true&"
import script from "./editCashierTransaction.vue?vue&type=script&lang=js&"
export * from "./editCashierTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3fbc84",
  null
  
)

export default component.exports